import { IonBackdrop, IonSpinner } from "@ionic/react";
import React from "react";
import "./LoadingBackdrop.css";

const LoadingBackdrop = (visualizar) => {
  return (
    <>
      <IonBackdrop visible={visualizar} />
      <div id="box">
        <IonSpinner name="crescent" />
        Cargando...
      </div>
    </>
  );
};

export default LoadingBackdrop;
